import type { Deck } from "./types";
import { seriesSeedPrimer } from "./decks/series-seed-primer";
import { seriesSeedPrimerV2 } from "./decks/series-seed-primer-v2";
import { seriesSeedPrimerV3 } from "./decks/series-seed-primer-v3";
import { seriesSeedPrimerV4 } from "./decks/series-seed-primer-v4";
import { seriesSeedPrimerV5 } from "./decks/series-seed-primer-v5";

interface DeckFamily {
  /** Funding round — the `<round>` in ir.apptonomy.ai/era/<round>/<slug>. */
  round: string;
  versions: Record<string, Deck>;
  /** Version served at the unversioned /era/<round>/<slug> path. */
  defaultVersion: string;
}

/** Keyed by deck slug — the `<slug>` in ir.apptonomy.ai/era/<round>/<slug>. */
export const deckFamilies: Record<string, DeckFamily> = {
  "series-seed-primer": {
    round: "seed",
    versions: {
      v1: seriesSeedPrimer,
      v2: seriesSeedPrimerV2,
      v3: seriesSeedPrimerV3,
      v4: seriesSeedPrimerV4,
      v5: seriesSeedPrimerV5,
    },
    defaultVersion: "v5",
  },
};

export function resolveDeck(
  round: string | undefined,
  deckSlug: string | undefined,
  version: string | undefined
): Deck | null {
  const family = deckSlug ? deckFamilies[deckSlug] : undefined;
  if (!family || family.round !== round) return null;
  return family.versions[version ?? family.defaultVersion] ?? null;
}
